import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

import { CardHeader } from './CardHeader';

export type CardContentProps = {
	name: React.ReactNode;
	description?: React.ReactNode;
	badge?: React.ReactNode;
	headerActions?: React.ReactNode;
	subtitle?: React.ReactNode;
	testId?: string;
};

const styles = cssMap({
	content: {
		gridArea: 'content',
		minWidth: 0,
		paddingInline: token('space.200'),
	},
});

export const CardContent = ({
	name,
	description,
	badge,
	headerActions,
	subtitle,
	testId,
}: CardContentProps): React.JSX.Element => {
	return (
		<Stack xcss={styles.content} space="space.075" testId={testId}>
			<CardHeader name={name} badge={badge} headerActions={headerActions} />
			{subtitle ? (
				<Text size="small" color="color.text.subtle">
					{subtitle}
				</Text>
			) : null}
			{description ? (
				<Text size="small" color="color.text.subtlest" maxLines={2}>
					{description}
				</Text>
			) : null}
		</Stack>
	);
};
